// extracted by mini-css-extract-plugin
export default {"KeywordsDataTable":"KeywordsTable_KeywordsDataTable__V6OgN","scrollable":"KeywordsTable_scrollable__elCt6"};